import { Component, inject, OnInit } from '@angular/core';

// interfaces
import { PageComponent } from '@sideline/sideline-apps-shared';

// services
import { AuthService, PageService } from '@sideline/sideline-apps-shared';

// components
import { NotFoundContent } from '../../components/not-found-content/not-found-content';
import { PublicLayout } from '../../../../layouts/public/layout/public.layout';
import { PublicPage } from "../../../../layouts/public/components/public-page/public-page";

@Component({
  selector: 'app-not-found-page',
  templateUrl: './not-found-page.html',
  styleUrl: './not-found-page.scss',
  standalone: true,
  imports: [
    NotFoundContent,
    PublicLayout,
    PublicPage,
  ]
})
export class NotFoundPage implements PageComponent, OnInit {

  title: string = 'Not Found';
  authenticated: boolean = false;

  // services
  private authService = inject(AuthService);
  pageService = inject(PageService);

  ngOnInit(): void {
    this.authenticated = this.authService.isAuthenticated();
    this.pageService.setTitle(this.title);
  }

}
